import {Injectable} from '@angular/core';
import {Product} from './product.model';
import {CrudService} from '@ngx-ivengi/crud';

@Injectable()
export class ProductService extends CrudService<Product> {
  public entityType = Product;
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/product/product.service.ts